import MarketingPageWrapper from '@/domain/Training/MarketingPageWrapper';
import MarketingHero from '@/domain/Training/MarketingHero';
import MarketingHighlightCopy from '@/domain/Training/MarketingHighlightCopy';
import MarketingContent from '@/domain/Training/MarketingContent';
import MarketingTrainers from '@/domain/Training/MarketingTrainers';
import MarketingFeatures from '@/domain/Training/MarketingFeatures';
import MarketingProgramSimple from '@/domain/Training/MarketingProgramSimple';
import MarketingTestimonials from '@/domain/Training/MarketingTestimonials';
import MarketingFAQs from '@/domain/Training/MarketingFAQs';
import MarketingContact from '@/domain/Training/MarketingContact';
import client from '@/api/client';
import { trainingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({
    query: trainingQuery,
    variables: {
      id: 'official-scrum-fundamentals-certification-training',
    },
  });

  return {
    props: {
      training: data?.training,
    },
  };
}

export default function TrainingMarketingPage({ training }) {
  const hasContent = training.content !== null;
  const hasTrainers = training.details.trainers !== null;
  const hasWhatIsLearned = training.details.whatIsLearned !== null;
  const hasProgramSubjects = training.details.programSubjects !== null;
  const hasTestimonials = training.details.testimonials !== null;
  const hasFAQs = training.details.faqs !== null;

  return (
    <MarketingPageWrapper>
      <MarketingHero
        heroCopy="Official Scrum Fundamentals"
        heroLead={
          <p className="leading-relaxed">
            El programa de entrenamiento&nbsp;
            <strong className="text-gray-900">
              más completo para hispanohablantes
            </strong>
            &nbsp;donde adquieres y desarrollas el dominio del marco de
            trabajo&nbsp;
            <strong className="text-gray-900">Scrum</strong>.
          </p>
        }
        heroImage="v1611708369/personas/official-scrum-fundamentals-certification_dm3r9u.png"
        heroImageAlt="Official Scrum Fundamentals Training"
        heroCTANormalClasses="bg-yellow-600"
        heroCTAHoverClasses="hover:bg-yellow-700"
        heroCTAFocusClasses="focus:bg-yellow-700 focus:ring-yellow-600 focus:ring-opacity-20"
        heroHighlighColor="text-yellow-600"
        heroBackgroundFrom="from-yellow-100"
        heroBackgroundTo="to-white"
        stripesBackgroundFrom="from-yellow-500"
        stripesBackgroundTo="to-transparent"
        stripesBackgroundDarkerFrom="from-yellow-600"
        stripesBackgroundDarkerTo="to-transparent"
        {...training.details}
      />
      <MarketingHighlightCopy>
        <p className="leading-relaxed">
          El programa&nbsp;
          <strong className="font-semibold text-white">
            Official Scrum Fundamentals
          </strong>
          &nbsp;te capacita en el dominio del&nbsp;
          <strong className="font-semibold text-white">
            marco de trabajo Scrum
          </strong>
          &nbsp;en cuanto a roles, eventos, artefactos y las reglas que los
          relacionan.
        </p>
      </MarketingHighlightCopy>
      {hasContent && <MarketingContent content={training.content} />}
      {hasTrainers && (
        <MarketingTrainers trainers={training.details.trainers} />
      )}
      {hasWhatIsLearned && (
        <MarketingFeatures features={training.details.whatIsLearned} />
      )}
      {hasProgramSubjects && (
        <MarketingProgramSimple program={training.details.programSubjects} />
      )}
      {hasTestimonials && (
        <MarketingTestimonials testimonials={training.details.testimonials} />
      )}
      {hasFAQs && <MarketingFAQs faqs={training.details.faqs} />}
      <MarketingContact />
    </MarketingPageWrapper>
  );
}
